import { getAnalyticsLanguageInfo } from 'src/utils/analytics/getAnalyticsLanguageInfo';
import { useMemo } from 'react';
import { getAnalyticsUserInfo } from 'src/utils/analytics/getAnalyticsUserInfo';
import { PremiumPrice } from 'src/api/internal/schema';
import { useIntl } from 'react-intl';
import { useUserContext } from 'src/context/user';

export function useViewItemListEvent(displayedPrices: PremiumPrice[]) {
  const intl = useIntl();
  const analyticsLanguageInfo = getAnalyticsLanguageInfo(intl);
  const { user } = useUserContext();
  const analyticsItemCategories = {
    ...(analyticsLanguageInfo.source_language && {
      item_category: analyticsLanguageInfo.source_language,
    }),
    ...(analyticsLanguageInfo.target_language && {
      item_category2: analyticsLanguageInfo.target_language,
    }),
  };

  const event = useMemo(
    () => ({
      event: 'view_item_list',
      page_screen_type: 'Subscriptions',
      page_screen_name: 'Subscriptions',
      ...analyticsLanguageInfo,
      ...getAnalyticsUserInfo(user),
      ecommerce: {
        currency: displayedPrices[0]?.currency,
        items: displayedPrices.map(p => ({
          item_id: p.key,
          item_name: p.paymentPeriod === 'lifetime' ? 'LIFETIME' : `1-${p.paymentPeriod}`,
          ...analyticsItemCategories,
          price: p.finalPrice,
          discount: p.discount?.priceDifference || 0,
          quantity: 1,
        })),
      },
    }),
    // We only want the event fired once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [displayedPrices],
  );

  return displayedPrices.length === 0 ? null : event;
}
